<template>
  <v-container>
    <v-row v-if="notification && notification.formatted">
      <v-col>
        <span class="text-h5">Select a Saved Search</span>

        <NotificationsSearches
          :selected="notification"
          :read-only="readOnly"
        ></NotificationsSearches>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";

import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { NOTIFICATION_TYPE_SAVED_SEARCH } from "@/common/constants/notifications";

export default {
  name: "NotificationsStepSearches",
  components: {
    NotificationsSearches: () =>
      import("@/components/notifications/NotificationsSearches"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorMessageName: null,
    };
  },
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
  },
  mounted() {
    const notification = lodashCloneDeep(this.notification);
    notification.formatted = notification.formatted || {};
    notification.formatted.docType = NOTIFICATION_TYPE_SAVED_SEARCH;
    this.update(notification);
  },
  methods: {
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
};
</script>

<style>
.hyp-types .v-btn-toggle {
  display: flex !important;
  flex-direction: column !important;
}
</style>
<style scoped></style>
